import { ACTION_TYPES, useUnidadesSaudeDispatch, useUnidadesSaudeState } from "./unidades-saude-context";
import MunicipalPortalAAppService from "application/platform/municipal-portal-service";
import { IUnidadeSaudePagedRequest } from "models/request/unidade-saude-paged-request";

export const useUnidadesSaudeController = () => {
    const unidadesSaudeDispatch = useUnidadesSaudeDispatch();
    const { unidadeSaudePagedRequest } = useUnidadesSaudeState();

    async function onInit() {
        let request = { page: 0, pageSize: 12 } as IUnidadeSaudePagedRequest;

        unidadesSaudeDispatch({ type: ACTION_TYPES.setUnidadeSaudePagedRequest, payload: request });
        await listUnidadesSaude(request, true);
    }

    async function listUnidadesSaude(request: IUnidadeSaudePagedRequest, showLoading: boolean = false) {
        try {
            if (showLoading) {
                unidadesSaudeDispatch({ type: ACTION_TYPES.setLoading, payload: true });
            }
            unidadesSaudeDispatch({ type: ACTION_TYPES.setError, payload: null });

            const unidadesSaude = await MunicipalPortalAAppService.listUnidadesSaude(request);

            unidadesSaudeDispatch({ type: ACTION_TYPES.setUnidadesSaude, payload: unidadesSaude });
        } catch (error) {
            console.log(error);
            unidadesSaudeDispatch({ type: ACTION_TYPES.setError, payload: 'Não foi possível carregar as unidades de saúde. Tente novamente mais tarde.' });
        } finally {
            if (showLoading) {
                unidadesSaudeDispatch({ type: ACTION_TYPES.setLoading, payload: false });
            }
        }
    }

    const handleOnChangeTerm = (e: React.ChangeEvent<HTMLInputElement>) => {
        unidadesSaudeDispatch({ type: ACTION_TYPES.setUnidadeSaudePagedRequest, payload: { ...unidadeSaudePagedRequest, term: e.target.value } });
    };

    return { listUnidadesSaude, handleOnChangeTerm, onInit };
}
